/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AwsSsmDocumentsBatchResponse {
    getFixupPrototypeFunction() { return AwsSsmDocumentsBatchResponse.fixupPrototype; }

    static newInstance(model: Partial<AwsSsmDocumentsBatchResponse>): AwsSsmDocumentsBatchResponse {
        let obj = Object.assign(new AwsSsmDocumentsBatchResponse(), model);
        AwsSsmDocumentsBatchResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AwsSsmDocumentsBatchResponse>): AwsSsmDocumentsBatchResponse {
        if (!model) return null;
        return AwsSsmDocumentsBatchResponse.newInstance(<AwsSsmDocumentsBatchResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AwsSsmDocumentsBatchResponse) {
        if (!obj) return;

        models.AwsSsmDocumentsBatchResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AwsSsmDocumentsBatchResponse): boolean {
        Object.setPrototypeOf(obj, AwsSsmDocumentsBatchResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.results) {
            for (let key in this.results) {
                let val = this.results[key];
                if (val) {
                    models.AwsSsmDocument.fixupPrototype(val);
                }
            }
        }
    }

    /**
     * Map from identifier to response model
     */
    results: { [key: string]: models.AwsSsmDocument; };

}
